export const environment = {
  production: false,
  apiBaseUrl: window.location.origin,
  // apiBaseUrl: 'https://dev.merakishippingservices.com',
  // apiBaseUrl: 'https://apps.merakishippingservices.com',
  // apiBaseUrl: 'http://127.0.0.1:5001',

  // apiBaseChUrl: 'http://127.0.0.1:80/',
  apiBaseChUrl: 'https://cargoheatingdev.merakishippingservices.com',

  // apiBasePcUrl: 'http://127.0.0.1:80/api',
  apiBasePcUrl: 'https://portconsumptiondev.merakishippingservices.com/api',


  apiBaseDemUrl: 'https://disbursementdev.merakishippingservices.com/api/v1',

};